/** Small RFC-4180 parser for the paste path. Handles commas, escaped quotes,
 * and newlines inside quoted cells; the upload path is parsed server-side. */
export function parseCsvText(value: string): string[][] {
  const rows: string[][] = []
  let row: string[] = []
  let cell = ''
  let quoted = false

  for (let index = 0; index < value.length; index += 1) {
    const char = value[index]
    if (char === '"') {
      if (quoted && value[index + 1] === '"') {
        cell += '"'
        index += 1
      } else {
        quoted = !quoted
      }
    } else if (char === ',' && !quoted) {
      row.push(cell.trim())
      cell = ''
    } else if ((char === '\n' || char === '\r') && !quoted) {
      if (char === '\r' && value[index + 1] === '\n') index += 1
      row.push(cell.trim())
      if (row.some((entry) => entry.length > 0)) rows.push(row)
      row = []
      cell = ''
    } else {
      cell += char
    }
  }
  if (quoted) throw new Error('The pasted CSV has an unclosed quoted cell.')
  row.push(cell.trim())
  if (row.some((entry) => entry.length > 0)) rows.push(row)
  return rows
}
